/**
 * @typedef {Object} BreadcrumbItem
 * @property {string} name -パンくずに表示されるタイトル
 * @property {string} url - パンくずのページURL
 */

/**
 *
 * @param {string} title ページタイトル
 * @param {string} description ページデスクリプション
 * @param {BreadcrumbItem[]} breadCrumb パンくずリスト
 *
 */

export function useCustomJsonld(breadCrumb) {
  const config = useRuntimeConfig()
  const pageUrl = `${config.public.docomoDomain}`

  useJsonld(() => (
    [{
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [
        ...breadCrumb.map((item, index) => {
          return {
            '@type': 'ListItem',
            'position': index + 1,
            'item': {
              ...(item.link ? { '@id': new URL(`${pageUrl}${item.link}`) } : {}),
              name: item.text
            }
          }
        })
      ]
    }
    ]
  ))
}
